import React from "react";

const ExpandIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={cls}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 2H13.1667V3.75H15.9958L12 7.81583L13.1783 9L17.25 5.05083V7.83333H19V2ZM2 19H7.83333V17.25H5.00417L9 13.1842L7.82167 12L3.75 15.9492V13.1667H2V19Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExpandIcon;
